import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { BootcampLandingPage } from "./BootcampLandingPage";

/* Halaman bootcamp — salinan 1:1 dari LP standalone (06. LP).
   Desain dibangun di atas skala 1920px → zoom 1.40625.
   Pakai CSS `zoom` di container halaman (bukan root font-size) supaya
   popup global (di-portal ke body) tidak ikut membesar. innerWidth ikut
   berubah saat browser zoom, jadi hasil akhir selalu setara 1920x1080 @100%
   mau layar gede/kecil, zoom berapa pun. */
export function BootcampPage() {
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    const update = () => {
      setZoom(window.innerWidth < 1024 ? 1 : window.innerWidth / 1366);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const goTiers = () => {
    const el = document.getElementById("bm-tiers");
    if (!el) return;
    window.scrollTo({ behavior: "smooth", top: el.getBoundingClientRect().top + window.scrollY - 70 });
  };

  return (
    <>
      <Helmet>
        <title>Bandarmolony Bootcamp — Belajar Membaca Pergerakan Bandar &amp; Broker</title>
        <meta
          name="description"
          content="Bandarmolony Bootcamp — Belajar membaca pergerakan bandar & broker: broker flow, bid-offer, dan technical analysis dalam satu framework."
        />
      </Helmet>
      <div style={{ zoom }}>
        <BootcampLandingPage onJoin={goTiers} />
      </div>
    </>
  );
}
